import { assert_hash_sha256_not_empty, assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO_REQUEST__collection_image_delete extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_COLLECTION__IMAGE_DELETE;

  /*
   *
   */
  collection_id!: string;
  hash_sha256_content!: string;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_object_id(this.collection_id);
    assert_hash_sha256_not_empty(this.hash_sha256_content);
  }
}
